import type { components } from "../../../api/generated";
import type { BusVehicleTypeCandidate, BusVehicleTypeItem, BusVehicleTypeMutation, BusVehicleTypePage } from "../types";

export type BusVehicleTypeCandidateRaw = components["schemas"]["BusVehicleTypeCandidate"];
export type BusVehicleTypeItemRaw = components["schemas"]["BusVehicleTypeItem"];
export type BusVehicleTypePageRaw = components["schemas"]["BusVehicleTypePage"];

/** 在契约边界映射车型候选，保留服务端顺序。 */
export function mapBusVehicleTypeCandidate(raw: BusVehicleTypeCandidateRaw): BusVehicleTypeCandidate {
  return { id: raw.vehicle_type_id, name: raw.name, seatCount: raw.seat_count, sortNo: raw.sort_no };
}

/** 映射管理记录审计字段。 */
export function mapBusVehicleTypeItem(raw: BusVehicleTypeItemRaw): BusVehicleTypeItem {
  return { ...mapBusVehicleTypeCandidate(raw), isDisabled: raw.is_disabled,
    createdAt: raw.created_at, updatedAt: raw.updated_at, createdBy: raw.created_by, updatedBy: raw.updated_by };
}

/** 映射管理列表的服务端分页。 */
export function mapBusVehicleTypePage(raw: BusVehicleTypePageRaw): BusVehicleTypePage {
  return { items: raw.items.map(mapBusVehicleTypeItem), total: raw.total, page: raw.page, pageSize: raw.page_size };
}

/** 仅发送可编辑字段，审计身份由后端认证提供。 */
export function mapBusVehicleTypeMutation(payload: BusVehicleTypeMutation): components["schemas"]["BusVehicleTypeMutation"] {
  return { name: payload.name, seat_count: payload.seatCount, sort_no: payload.sortNo, is_disabled: payload.isDisabled };
}
